// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal2 {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
}
.modal2__container {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    width: 40%;
    max-height: 95%;
    display: flex;
    flex-direction: column;
}
.modal2.medium .modal2__container {
    width: 66%;
}
.modal2.large .modal2__container {
    width: 100%;
    margin: var(--space);
}

.modal2__header {
    background: var(--white-color);
    position: relative;
    padding: var(--space-half-quarter) var(--space);
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid  var(--new-input-background-color);
    align-items: center;
}
.modal2__header__close {
    cursor: pointer;
    /* border-bottom: 1px solid var(--new-input-background-color);
    padding: var(--space-half-quarter) var(--space-quarter) var(--space-quarter); */
}

.modal2__header__close_icon {
   color: var(--primary-dark-color);
	font-size: var(--space-x2);
	
	cursor: pointer;
	align-self: right;
	margin-left: auto;
   
}

.modal2__header__title {
   font-family: var(--secondary-font);
   font-style: normal;
   font-weight: var(--font-medium);
   font-size: calc(var(--space) + var(--space-quarter));/* 20px */;
   line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth) + 1px);/* 23px */
   letter-spacing: 0.0015em;
   color: var(--black-color);   
   padding-top: var(--space-half);
   color: var(--primary-very-dark-color) !important;   
}

.modal2__content {
    background: var(--white-color);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.modal2__header__clear-btn.icon-x {
    color: var( --primary-very-dark-color );
    cursor: pointer;
    margin-left: auto;
    font-size: var(--space-x2);
}

.modal2__header__horizontal-line {
   width: 100%;
   height: 10px;
   margin-left: 0px;
   border: 1px solid var(--new-input-label-color);
   background: var(--white-color);
}

/* Desktop */
@media screen and ( max-width: 1440px ) {

    .modal2__container {
        width: 60%;
    }
    .modal2.medium .modal2__container {
        width: 80%;
    }
    .modal2.large .modal2__container {
        width: 100%;
        margin: var(--space);
    }

}

/* Tablet */

@media screen and ( max-width: 992px ) {

    .modal2__container {
        width: 80%;
    }
    .modal2.medium .modal2__container {
        width: 100%;
        margin: var(--space);
    }

}

/* Mobile */

@media screen and ( max-width: 576px ) {
    
    .modal2__container {
        width: 100%;
        margin: var(--space);
    }

}

@media screen and ( max-width: 320px ) {
    
    .modal2__container {
        width: 100%;
        margin: 0;
        max-height: 100%;
    }

    .modal2.medium .modal2__container {
        width: 100%;
        margin: 0;
    }

}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .modal2__header {
        border-bottom: 0;
        padding-bottom: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/modal2/Modal2Component.styles.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iDAAiD;IACjD,UAAU;IACV,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,+CAA+C;IAC/C,aAAa;IACb,8BAA8B;IAC9B,2DAA2D;IAC3D,mBAAmB;AACvB;AACA;IACI,eAAe;IACf;mFAC+E;AACnF;;AAEA;GACG,gCAAgC;CAClC,0BAA0B;;CAE1B,eAAe;CACf,iBAAiB;CACjB,iBAAiB;;AAElB;;AAEA;GACG,kCAAkC;GAClC,kBAAkB;GAClB,+BAA+B;GAC/B,oDAAoD,CAAC,SAAS;GAC9D,kFAAkF,CAAC,SAAS;GAC5F,wBAAwB;GACxB,yBAAyB;GACzB,8BAA8B;GAC9B,gDAAgD;AACnD;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uCAAuC;IACvC,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,gBAAgB;GAChB,8CAA8C;GAC9C,8BAA8B;AACjC;;AAEA,YAAY;AACZ;;IAEI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;;AAEJ;;AAEA,WAAW;;AAEX;;IAEI;QACI,UAAU;IACd;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;;AAEJ;;AAEA,WAAW;;AAEX;;IAEI;QACI,WAAW;QACX,oBAAoB;IACxB;;AAEJ;;AAEA;;IAEI;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,SAAS;IACb;;AAEJ;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ","sourcesContent":["\n.modal2 {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 100;\n}\n.modal2__container {\n    border-radius: 14px;\n    overflow: hidden;\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    width: 40%;\n    max-height: 95%;\n    display: flex;\n    flex-direction: column;\n}\n.modal2.medium .modal2__container {\n    width: 66%;\n}\n.modal2.large .modal2__container {\n    width: 100%;\n    margin: var(--space);\n}\n\n.modal2__header {\n    background: var(--white-color);\n    position: relative;\n    padding: var(--space-half-quarter) var(--space);\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid  var(--new-input-background-color);\n    align-items: center;\n}\n.modal2__header__close {\n    cursor: pointer;\n    /* border-bottom: 1px solid var(--new-input-background-color);\n    padding: var(--space-half-quarter) var(--space-quarter) var(--space-quarter); */\n}\n\n.modal2__header__close_icon {\n   color: var(--primary-dark-color);\n\tfont-size: var(--space-x2);\n\t\n\tcursor: pointer;\n\talign-self: right;\n\tmargin-left: auto;\n   \n}\n\n.modal2__header__title {\n   font-family: var(--secondary-font);\n   font-style: normal;\n   font-weight: var(--font-medium);\n   font-size: calc(var(--space) + var(--space-quarter));/* 20px */;\n   line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth) + 1px);/* 23px */\n   letter-spacing: 0.0015em;\n   color: var(--black-color);   \n   padding-top: var(--space-half);\n   color: var(--primary-very-dark-color) !important;   \n}\n\n.modal2__content {\n    background: var(--white-color);\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.modal2__header__clear-btn.icon-x {\n    color: var( --primary-very-dark-color );\n    cursor: pointer;\n    margin-left: auto;\n    font-size: var(--space-x2);\n}\n\n.modal2__header__horizontal-line {\n   width: 100%;\n   height: 10px;\n   margin-left: 0px;\n   border: 1px solid var(--new-input-label-color);\n   background: var(--white-color);\n}\n\n/* Desktop */\n@media screen and ( max-width: 1440px ) {\n\n    .modal2__container {\n        width: 60%;\n    }\n    .modal2.medium .modal2__container {\n        width: 80%;\n    }\n    .modal2.large .modal2__container {\n        width: 100%;\n        margin: var(--space);\n    }\n\n}\n\n/* Tablet */\n\n@media screen and ( max-width: 992px ) {\n\n    .modal2__container {\n        width: 80%;\n    }\n    .modal2.medium .modal2__container {\n        width: 100%;\n        margin: var(--space);\n    }\n\n}\n\n/* Mobile */\n\n@media screen and ( max-width: 576px ) {\n    \n    .modal2__container {\n        width: 100%;\n        margin: var(--space);\n    }\n\n}\n\n@media screen and ( max-width: 320px ) {\n    \n    .modal2__container {\n        width: 100%;\n        margin: 0;\n        max-height: 100%;\n    }\n\n    .modal2.medium .modal2__container {\n        width: 100%;\n        margin: 0;\n    }\n\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .modal2__header {\n        border-bottom: 0;\n        padding-bottom: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
